export const CUSTOMER_SUPPORT = 'https://support.westfield.com.au/hc/en-us';
export const COVID_INFORMATION = '/customer-updates/coronavirus';
export const WESTFIELD_DIRECT = '/';
export const SHOP_ABOUT = '/shop/info';
export const SHOP_CLICK_COLLECT = '/shop/info/click-and-collect';
export const SHOP_DELIVERY = '/shop/info/delivery';
export const SHOP_RETURNS = '/shop/info/returns';
export const SHOP_REWARDS = '/shop/info/rewards';
export const SHOP_SIZE_GUIDE = '/shop/info/size-guides';
export const GIFT_CARDS_DIGITAL_RETAIL = 'http://www.westfield.com.au/shop/westfield-digital-gift-card';
export const GIFT_CARDS_PHYSICAL_RETAIL = 'https://www.westfieldgiftcards.com.au/Online/Order/OrderCard';
export const GIFT_CARDS_PHYSICAL_CORPORATE = 'https://www.westfieldgiftcards.com.au/Corporate';
export const WESTFIELD_PLUS = '/westfield-plus';
export const RESPONSIBLE_BUSINESS_REPORT = 'https://www.scentregroup.com/getmedia/b11da19e-2b79-4b72-b40e-2700ee3e4cc8/2021-Responsible-Business-Report.pdf';
export const CAREERS = 'https://www.scentregroup.com/careers';
export const LEASING_MEDIA = 'https://www.scentregroup.com/Retail-Solutions/Contact-us';
export const RESPONSIBLE_BUSINESS = 'https://www.scentregroup.com/about-us/sustainability';
export const PRIVACY_POLICY = '/privacy-policy';
export const TERMS_CONDITIONS = '/terms-and-conditions';
export const FAQS = 'https://support.westfield.com.au/hc/en-us';
export const SCENTRE_GROUP_HOME = 'https://www.scentregroup.com';
export const TERMS_CONDITIONS_WESTFIELD_DIRECT = '/terms-and-conditions#westfield-direct-terms-and-conditions';
export const PRIVACY_POLICY_WESTFIELD_DIRECT = '/privacy-policy#westfield-direct-privacy-statement';
export const TERMS_CONDITIONS_WESTFIELD_PLUS = '/terms-and-conditions#westfield-plus-terms-and-conditions';
export const PRIVACY_POLICY_WESTFIELD_PLUS = '/privacy-policy#westfield-plus-privacy-statement';
export const FAQS_WESTFIELD_PLUS = 'https://support.westfield.com.au/hc/en-us/categories/360002581332-Westfield-Plus-AU';